import { useEffect } from "react";
import SortableTree, {
  getTreeFromFlatData,
  getFlatDataFromTree,
  changeNodeAtPath,
  removeNodeAtPath,
  walk,
} from "react-sortable-tree";

import CustomNodeContentRenderer from "../layerTree/CustomNodeContentRendererNoHide";
import { useSelector } from "react-redux";
import store from "../../stores/store";
import {
  getLayerById,
  mapAddControl,
  mapGetControl,
  mapRemoveControl,
  removeLayerCQL,
  removeLayerSLD,
  setLayerOpacity,
  setLayerProperty,
  setLayerVisibility,
  setLayerZIndex,
  setSLD,
  zoomToExtent,
} from "../map/mapUtils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Checkbox from "react-three-state-checkbox";
import { cloneDeep } from "lodash";
import { key, showDataTable, trans } from "../../lib/utils";
import TimeDimensionDropdown from "../controls/timeDimensionDropdown";
import DownloadFeatures from "../controls/downloadFeatures";
import Swipe from "ol-ext/control/Swipe";
import "ol-ext/dist/ol-ext.css";

function SwipePanel() {
  const layerTree = useSelector((state) => store.getState().layerTree);
  const sources = useSelector((state) => store.getState().sources);
  const layers = useSelector((state) => store.getState().layers);
  const swipeLayers = useSelector((state) => store.getState().swipe.layers);
  const swipeTree = useSelector((state) => store.getState().swipe.tree);
  const swipeStatus = useSelector((state) => store.getState().swipe.status);
  const timeDimensionLayers = useSelector(
    (state) => store.getState().timeDimension.layers
  );
  const cqlFilters = useSelector((state) => store.getState().cqlFilter);
  const sldEditors = useSelector(
    (state) => store.getState().sldEditor.sldEditors
  );

  const swipeInit = () => {
    mapRemoveControl("swipe");
    if (swipeStatus) {
      let swipeControl = new Swipe();

      swipeControl.controlId = "swipe";

      mapAddControl(swipeControl);
    }
  };

  useEffect(() => {
    swipeInit();
  }, [swipeStatus]);

  function setLayerSwipePosition(layer, position) {
    let swipeControl = mapGetControl("swipe");

    swipeControl.removeLayer(getLayerById(layer.id));

    switch (position) {
      case "left":
        swipeControl.addLayer(getLayerById(layer.id));
        break;

      case "right":
        swipeControl.addLayer(getLayerById(layer.id), true);
        break;
    }
  }

  return (
    <PerfectScrollbar className="scrollbar-recaclulate">
      <div className="mt-2">
        <button
          className="btn btn-sm btn-link border"
          onClick={() => {
            store.dispatch({ type: "swipe/toggle" });
          }}
        >
          {swipeStatus ? trans("Deactivate swipe") : trans("Activate swipe")}
        </button>
      </div>
      <SortableTree
        treeData={swipeTree}
        isVirtualized={false}
        onMoveNode={(args) => {}}
        onChange={(_treeData) => {
          if (swipeStatus) {
            walk({
              treeData: _treeData,
              getNodeKey: ({ treeIndex }) => treeIndex,
              ignoreCollapsed: true,
              callback: (rowInfoIter) => {
                setLayerZIndex(
                  { id: rowInfoIter.node.id },
                  1500 - rowInfoIter.treeIndex
                );
              },
            });
          }
          store.dispatch({
            type: "swipe/tree/update",
            payload: _treeData,
          });
        }}
        nodeContentRenderer={CustomNodeContentRenderer}
        generateNodeProps={({ node, path, treeIndex }) => ({
          more: () => {
            if (node.type === "layer") {
              if (!layers[node.layer.id]) {
                return null;
              }

              return (
                <div
                  id={"collapse-".concat(node.key)}
                  className=" mb-3 bg-white border-top border-bottom p-2"
                >
                  <div>
                    <div className=" mt-1 ">
                      <small className="text-secondary">
                        {trans("Name")}: {layers[node.id]?.name}
                      </small>
                    </div>
                    <div className="mb-2 d-flex mt-2">
                      <label className="form-label small mb-0 me-2">
                        {trans("Opacity")} {layers[node.id]?.opacity}
                      </label>
                      <input
                        type="range"
                        min="1"
                        max="10"
                        value={layers[node.id]?.opacity * 10}
                        className=" w-100 d-block me-2"
                        onChange={(e) => {
                          setLayerOpacity(layers[node.id], e.target.value / 10);
                          store.dispatch({
                            type: "swipe/layer/update",
                            payload: {
                              id: node.layer.id,
                              property: "opacity",
                              value: e.target.value / 10,
                            },
                          });
                        }}
                      ></input>
                    </div>

                    <div className="mb-3 " style={{ whiteSpace: "normal" }}>
                      <button
                        type="button"
                        className="btn btn-sm btn-link border small m-1"
                        onClick={(e) => {
                          zoomToExtent(layers[node.id]);
                        }}
                      >
                        <i className="fas fa-compress me-2"></i>
                        {trans("Zoom to extent")}
                      </button>

                      {node.layer.searchable ? (
                        <button
                          type="button"
                          className="btn btn-sm btn-link border small m-1"
                          onClick={(e) => {
                            if (node.layer) {
                              showDataTable(
                                layers[node.layer.id],
                                sources[node.layer.source.id]
                              );
                            }
                          }}
                        >
                          <i className="far fa-list-alt me-2"></i>
                          {trans("Data table")}
                        </button>
                      ) : (
                        ""
                      )}

                      {layers[node.id].searchable ? (
                        <button
                          type="button"
                          className="btn btn-sm btn-link border small m-1"
                          data-bs-toggle="collapse"
                          data-bs-target={"#sidebar"}
                          onClick={(e) => {
                            store.dispatch({
                              type: "search/update",
                              payload: { id: node.id, groups: [] },
                            });

                            store.dispatch({
                              type: "app/leftPanelActiveTab",
                              payload: "search",
                            });
                          }}
                        >
                          <i className="far fa-list-alt me-2"></i>
                          {trans("Search features")}
                        </button>
                      ) : (
                        ""
                      )}

                      <div className="dropdown d-inline-block">
                        <button
                          className="btn btn-sm btn-link border small m-1 d-inline-block dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {trans("More")}
                        </button>
                        <ul
                          className="dropdown-menu small"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <span
                              className="dropdown-item small"
                              role="button"
                              onClick={() => {
                                store.dispatch({
                                  type: "swipe/layer/toggle",
                                  payload: layers[node.id],
                                });
                              }}
                            >
                              {swipeLayers[node.id]
                                ? trans("Remove from swipe")
                                : trans("Add to swipe")}
                            </span>
                          </li>
                          {swipeLayers[node.id]?.source?.type !== "GEOJSON" ? (
                            <li>
                              <span
                                className="dropdown-item small"
                                role="button"
                                onClick={() => {
                                  window["primaryModal"].setState({
                                    title: trans("Download features"),
                                    show: true,
                                    body: (
                                      <DownloadFeatures
                                        layer={layers[node.id]}
                                      ></DownloadFeatures>
                                    ),
                                  });
                                }}
                              >
                                {trans("Download")}
                              </span>
                            </li>
                          ) : (
                            ""
                          )}
                          <li>
                            <span
                              className="dropdown-item small"
                              role="button"
                              onClick={() => {
                                getLayerById(node.id).getSource().refresh();
                              }}
                            >
                              {trans("Refresh")}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    {swipeLayers[node.id] ? (
                      <span className="badge bg-warning text-dark m-1">
                        <small>{trans("Swipe selected")}</small>
                      </span>
                    ) : (
                      ""
                    )}
                    {layers[node.id].cqlFilter ? (
                      <span className="badge bg-warning text-dark m-1">
                        <small>{trans("CQL Filter enabled")}</small>
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    {timeDimensionLayers[node.id]?.dimensions ? (
                      <TimeDimensionDropdown
                        layer={timeDimensionLayers[node.id]}
                        value={timeDimensionLayers[node.id].defaultDimension}
                        dimensions={timeDimensionLayers[node.id]?.dimensions}
                      ></TimeDimensionDropdown>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mb-3">
                    <ul className="nav nav-tabs navbar-expand small">
                      <li className={"nav-item "}>
                        <span
                          className="nav-link color-strong-grey nav-ellipsis active"
                          role="button"
                          data-bs-toggle="tab"
                          data-bs-target={"#swipe-tab1-".concat(node.id)}
                        >
                          <span className="color-black">{trans("Legend")}</span>
                        </span>
                      </li>
                      <li className={"nav-item "}>
                        <span
                          className="nav-link color-strong-grey nav-ellipsis "
                          data-bs-toggle="tab"
                          role="button"
                          data-bs-target={"#swipe-tab2-".concat(node.id)}
                        >
                          <span className="color-black">
                            {trans("Description")}
                          </span>
                        </span>
                      </li>
                      {layers[node.id]?.searchable ? (
                        <li className={"nav-item "}>
                          <span
                            className="nav-link color-strong-grey nav-ellipsis "
                            data-bs-toggle="tab"
                            role="button"
                            data-bs-target={"#swipe-tab3-".concat(node.id)}
                          >
                            <span className="color-black">
                              {trans("CQL Filter")}
                            </span>
                          </span>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                    <div className="tab-content mt-3 ">
                      <div
                        className={"tab-pane fade active show"}
                        id={"swipe-tab1-".concat(node.id)}
                        role="tabpanel"
                        aria-labelledby="legend-tab"
                      >
                        {layers[node.id]?.slds ? (
                          <div className="mb-3">
                            <label className="form-label small mb-1 me-2">
                              {trans("Available SLDs")}
                            </label>
                            <select
                              className="form-select form-select-sm"
                              onChange={(e) => {
                                store.dispatch({
                                  type: "swipe/layer/update",
                                  payload: {
                                    property: "activeSLD",
                                    value: e.target.value,
                                    id: node.id,
                                  },
                                });

                                if (!e.target.value) {
                                  removeLayerSLD(layers[node.id]);
                                } else {
                                  setSLD(
                                    layers[node.id],
                                    e.target.value,
                                    sldEditors[node.id]
                                  );
                                }
                              }}
                              value={layers[node.id].activeSLD}
                            >
                              <option value="">{trans("Default")}</option>
                              {layers[node.id].slds.map((el) => {
                                return (
                                  <option value={el.sldId}>{el.title}</option>
                                );
                              })}
                            </select>
                          </div>
                        ) : (
                          ""
                        )}
                        <img
                          src={layers[node.id]?.legend}
                          className="ms-1 me-2"
                          style={{ maxWidth: "30rem" }}
                        ></img>
                      </div>
                      <div
                        className={"tab-pane fade p-2"}
                        id={"swipe-tab2-".concat(node.id)}
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                      >
                        <span
                          className="small d-block mb-2"
                          style={{
                            whiteSpace: "pre-wrap",
                            overflowY: "auto",
                          }}
                        >
                          {layers[node.id]?.abstract}
                        </span>
                      </div>
                      <div
                        className={"tab-pane fade "}
                        id={"swipe-tab3-".concat(node.id)}
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                      >
                        <button
                          className="btn btn-sm btn-link border small m-1 d-inline-block"
                          type="button"
                          aria-expanded="false"
                          data-bs-toggle="collapse"
                          data-bs-target={"#sidebar"}
                          onClick={(e) => {
                            let cqlFilter = cqlFilters.cqlFilters;

                            store.dispatch({
                              type: "cqlFilter/update",
                              payload: {
                                id: layers[node.id].id,
                                groups: cqlFilter[node.id]
                                  ? cqlFilter[node.id]?.groups
                                    ? cqlFilter[node.id].groups
                                    : []
                                  : [],
                              },
                            });

                            store.dispatch({
                              type: "app/leftPanelActiveTab",
                              payload: "cqlFilter",
                            });
                          }}
                        >
                          <i className="fas fa-filter me-2"></i>
                          {layers[node.id].cqlFilter
                            ? trans("Edit CQL Filter")
                            : trans("Add CQL Filter")}
                        </button>
                        {layers[node.id].cqlFilter ? (
                          <button
                            className="btn btn-sm btn-link border small m-1 d-inline-block"
                            type="button"
                            aria-expanded="false"
                            data-bs-toggle="collapse"
                            data-bs-target={"#sidebar"}
                            onClick={(e) => {
                              removeLayerCQL(layers[node.id]);
                              store.dispatch({
                                type: "cqlFilter/layer/delete",
                                payload: {
                                  id: layers[node.id].id,
                                },
                              });
                            }}
                          >
                            <i className="fas fa-filter me-2"></i>
                            {trans("Remove CQL Filter")}
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          },
          remove: () => {
            if (node.type === "layer") {
              window["primaryModal"].setState({
                show: true,
                size: "default",
                title: trans("Remove from swipe confirmation"),
                body: (
                  <div className="p-2">
                    {trans("Are you sure you want to remove layer")}{" "}
                    <strong>"{layers[node.id].title}"</strong>
                  </div>
                ),
                footer: [
                  <button
                    className="btn btn-sm btn-link"
                    onClick={(e) => {
                      window["primaryModal"].setState({
                        show: false,
                      });
                    }}
                  >
                    {trans("Cancel")}
                  </button>,
                  <button
                    className="btn btn-sm btn-danger text-white"
                    onClick={(e) => {
                      store.dispatch({
                        type: "swipe/layer/toggle",
                        payload: layers[node.id],
                      });

                      setTimeout(swipeInit, 500);

                      window["primaryModal"].setState({
                        show: false,
                      });
                    }}
                  >
                    {trans("Delete")}
                  </button>,
                ],
              });
            }
          },
          title: () => {
            let loaded = false;
            if (node.type === "layer") {
              if (layers[node.layer.id]) {
                if (layers[node.layer.id].loaded) {
                  loaded = true;
                }
              }
            }

            return (
              <>
                <div
                  className="d-flex mt-1 "
                  style={{
                    alignItems: "flex-start",
                  }}
                >
                  <Checkbox
                    checked={swipeLayers[node.id].visibility}
                    className="d-flex mt-1 me-1 ms-2"
                    onChange={(e) => {
                      let updatedNode = cloneDeep(node);
                      updatedNode.checked = e.currentTarget.checked;

                      if (node.type === "layer") {
                        setLayerVisibility(node.layer, e.currentTarget.checked);
                        store.dispatch({
                          type: "swipe/layer/update",
                          payload: {
                            id: node.layer.id,
                            property: "visibility",
                            value: e.currentTarget.checked,
                          },
                        });
                      }

                      function reccursive(data) {
                        return data?.children?.map((el) => {
                          el.checked = e.currentTarget.checked;

                          if (el.type === "layer") {
                            setLayerVisibility(
                              el.layer,
                              e.currentTarget.checked
                            );
                            let id = el.layer.id;
                            store.dispatch({
                              type: "swipe/layer/update",
                              payload: {
                                id: id,
                                property: "visibility",
                                value: e.currentTarget.checked,
                              },
                            });
                          }

                          reccursive(el);

                          return el;
                        });
                      }

                      updatedNode.children = reccursive(updatedNode);

                      const newTree = changeNodeAtPath({
                        treeData: swipeTree,
                        path,
                        getNodeKey: ({ treeIndex }) => treeIndex,
                        newNode: updatedNode,
                      });

                      store.dispatch({
                        type: "swipe/tree/update",
                        payload: newTree,
                      });
                    }}
                  />

                  {node.type === "layer" ? (
                    <span
                      className={"small d-block ".concat(
                        !loaded ? "text-muted" : ""
                      )}
                      role="button"
                      disable
                      onClick={() => {}}
                    >
                      {!loaded ? (
                        <i
                          className="fas fa-exclamation-triangle me-1"
                          title={trans("Layer not loaded yet")}
                        ></i>
                      ) : (
                        ""
                      )}
                      {layers[node.id] ? (
                        layers[node.id].cqlFilter ? (
                          <i
                            className="fas fa-filter me-1"
                            title="CQL Filter enabled"
                          ></i>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      {layers[node.id] ? layers[node.id].title : node.title}
                    </span>
                  ) : (
                    <span
                      className="small d-block"
                      role="button"
                      disable
                      onClick={() => {}}
                    >
                      {layers[node.id] ? layers[node.id].title : node.title}
                    </span>
                  )}
                </div>
                <div className="mt-2">
                  <span className="btn btn-sm">{trans("Swipe position")}:</span>
                  <button
                    className={"btn btn-sm btn-link border ".concat(
                      swipeLayers[node.id].swipePosition === "left"
                        ? " bg-get-blue text-white"
                        : ""
                    )}
                    disabled={!swipeStatus}
                    style={{
                      borderBottomRightRadius: 0,
                      borderTopRightRadius: 0,
                    }}
                    onClick={() => {
                      setLayerSwipePosition(node.layer, "left");
                      store.dispatch({
                        type: "swipe/layer/update",
                        payload: {
                          id: node.layer.id,
                          property: "swipePosition",
                          value: "left",
                        },
                      });
                    }}
                  >
                    {trans("Left")}
                  </button>
                  <button
                    className={"btn btn-sm btn-link border-top border-bottom ".concat(
                      swipeLayers[node.id].swipePosition === "both" ||
                        !swipeLayers[node.id].swipePosition
                        ? " bg-get-blue text-white"
                        : ""
                    )}
                    disabled={!swipeStatus}
                    onClick={() => {
                      setLayerSwipePosition(node.layer, "both");
                      store.dispatch({
                        type: "swipe/layer/update",
                        payload: {
                          id: node.layer.id,
                          property: "swipePosition",
                          value: "both",
                        },
                      });
                    }}
                    style={{ borderRadius: 0 }}
                  >
                    {trans("Both")}
                  </button>
                  <button
                    className={"btn btn-sm btn-link border ".concat(
                      swipeLayers[node.id].swipePosition === "right"
                        ? " bg-get-blue text-white"
                        : ""
                    )}
                    disabled={!swipeStatus}
                    style={{
                      borderBottomLeftRadius: 0,
                      borderTopLeftRadius: 0,
                    }}
                    onClick={() => {
                      setLayerSwipePosition(node.layer, "right");
                      store.dispatch({
                        type: "swipe/layer/update",
                        payload: {
                          id: node.layer.id,
                          property: "swipePosition",
                          value: "right",
                        },
                      });
                    }}
                  >
                    {trans("Right")}
                  </button>
                  {!swipeStatus ? (
                    <span className="d-block small text-muted ps-2">
                      {trans("You need to activate swipe to change positions")}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </>
            );
          },
        })}
      ></SortableTree>
    </PerfectScrollbar>
  );
}

export default SwipePanel;
